var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"label",style:({color: _vm.rowData.source.color, backgroundColor: _vm.rowData.source.background_color}),attrs:{"id":"example"},on:{"click":function($event){$event.preventDefault();return _vm.toggleDetailRow($event)}}},[_vm._v("\n    "+_vm._s(_vm.rowData.source.name)+"\n")])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f83e277","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Contacts/Components/SourceLabel.vue
// module id = UJ8u
// module chunks = 0